module.exports = __webpack_public_path__ + "static/img/2012.25aa56d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/newEvents/2012.png
// module id = hHEu
// module chunks = 1